export const NeurodiversitySessionTypes = {
  CAREGIVER_TRAINING_FOR_NEURO_SESSION: 'caregiver_training_for_neuro_session',
  NEURODIVERSITY_SKILLS_COACHING_SESSION: 'neurodiversity_skills_coaching_session',
} as const

export const CoachingSessionTypes = {
  SMP_SESSION: 'smp_session',
  INTL_SMP_SESSION: 'intl_smp_session',
  SSC_SESSION: 'ssc_session',
  COACHING_FOR_PARENTS_SESSION: 'coaching_for_parents_session',
  CGT_SESSION: 'caregiver_training_for_neuro_session',
  NSC_SESSION: 'neurodiversity_skills_coaching_session',
  MANAGER_COACHING_SESSION: 'manager_coaching_session',
} as const

// Session types for LT providers
export const LTSessionTypes = {
  AUD_SESSION: 'alcohol_use_disorder_session',
  BCT_SESSION: 'lyra_therapy_session',
  DBT_SESSION: 'dbt_session',
  DBT_GROUP_SESSION: 'dbt_group_session',
  DBT_TEENS_SESSION: 'dbt_teens_session',
  DBT_TEENS_INTAKE_SESSION: 'dbt_teens_intake_session',
  DBT_TEENS_FOLLOWUP_SESSION: 'dbt_teens_followup_session',
  DBT_TEENS_CAREGIVER_SESSION: 'dbt_teens_caregiver_session',
  DBT_TEENS_FAMILY_SESSION: 'dbt_teens_family_session',
  DBT_TEENS_GROUP_SESSION: 'dbt_teens_group_session',
  DBT_TEENS_MEDICATION_INITIAL_SESSION: 'dbt_teens_medication_initial_session',
  DBT_TEENS_MEDICATION_FOLLOWUP_SESSION: 'dbt_teens_medication_followup_session',
  LCTT_SESSION: 'lyra_therapy_teens_session',
  INITIAL_MEDS_SESSION: 'lyra_therapy_meds_initial_session',
  FOLLOWUP_MEDS_SESSION: 'lyra_therapy_meds_follow_up_session',
  INITIAL_CLE_SESSION: 'clinical_leave_evaluation_initial_session',
  FOLLOWUP_CLE_SESSION: 'clinical_leave_evaluation_follow_up_session',
  INITIAL_DA_SESSION: 'individual_initial_evaluation',
  INITIAL_DA_CHILD_SESSION: 'child_initial_evaluation',
  FOLLOWUP_DA_SESSION: 'individual_follow_up_session',
  FOLLOWUP_DA_CHILD_SESSION: 'child_follow_up_session',
  INITIAL_DA_COUPLES_SESSION: 'couples_initial_evaluation',
  FOLLOWUP_DA_COUPLES_SESSION: 'couples_follow_up_session',
  INITIAL_DA_FAMILY_SESSION: 'family_initial_evaluation',
  FOLLOWUP_DA_FAMILY_SESSION: 'family_follow_up_session',

  ...CoachingSessionTypes,
} as const

export type LTSessionType = (typeof LTSessionTypes)[keyof typeof LTSessionTypes]

export enum SessionCostEstimateDisplayState {
  AVAILABLE = 'available',
  DEFERRED = 'deferred',
  LOADING = 'loading',
  UNAVAILABLE = 'unavailable',
}

// DBT for Teens group session types, intentionally excluded from the member-facing session
// list for the MVP (they are joined off-platform and do not generate reminders) — LCDELIVERY-7302.
// Deliberately does NOT include the adult `dbt_group_session`: adult DBT members' group sessions
// must not disappear when the teens flag is enabled.
export const GROUP_SESSION_TYPES = new Set<string>([LTSessionTypes.DBT_TEENS_GROUP_SESSION])

export const isGroupSessionType = (sessionType?: string | null): boolean =>
  sessionType != null && GROUP_SESSION_TYPES.has(sessionType)

// Caregiver / "Parenting" session types. In DBT for Teens these are for the caregiver, so a teen
// cannot schedule them and they are hidden from the teen's session list — see LCDELIVERY-7302.
export const CAREGIVER_SESSION_TYPES = new Set<string>([LTSessionTypes.DBT_TEENS_CAREGIVER_SESSION])

export const isCaregiverSessionType = (sessionType?: string | null): boolean =>
  sessionType != null && CAREGIVER_SESSION_TYPES.has(sessionType)

export const DBT_TEENS_SESSION_TYPE_LABELS: Record<string, string> = {
  [LTSessionTypes.DBT_TEENS_SESSION]: 'Teen session',
  [LTSessionTypes.DBT_TEENS_INTAKE_SESSION]: 'Intake session',
  [LTSessionTypes.DBT_TEENS_FOLLOWUP_SESSION]: 'Teen session',
  [LTSessionTypes.DBT_TEENS_CAREGIVER_SESSION]: 'Caregiver session',
  [LTSessionTypes.DBT_TEENS_FAMILY_SESSION]: 'Family session',
  [LTSessionTypes.DBT_TEENS_GROUP_SESSION]: 'Group session',
  [LTSessionTypes.DBT_TEENS_MEDICATION_INITIAL_SESSION]: 'Medication session',
  [LTSessionTypes.DBT_TEENS_MEDICATION_FOLLOWUP_SESSION]: 'Medication session',
}
